import {
	ADD_DATA,
	INCREASE_CURRENT_PAGE_COUNTER,
	SET_CURRENT_PAGE,
	SET_CURRENT_PAGE_LOADED_STATE,
	SET_INITIAL_DATA_LOADED_STATE,
	SET_INITIAL_STATE,
	SET_NR_OF_PAGES,
	SET_PARAMS,
	SET_SORT_KEY,
	SET_VIDEOS,
} from '../../constants/mutations';
import { SORT_KEYS } from '../../constants/api';
import ApiClient from '../../api';
import { formatSecondsAsHoursAndMinutes } from '../../util/timeFormat';
import { formatTimestampAsMinutesSeconds } from '@shared/utils/timeUtils';

const getInitialState = () => ({
	sortKey:           SORT_KEYS.NEWEST_FIRST,
	currentPage:       1,
	nrOfPages:         0,
	videos:            [],
	initialDataLoaded: false,
	currentPageLoaded: false,
	params:            [],
});

export default {
	namespaced: true,
	state:      getInitialState,
	mutations:  {
		[SET_SORT_KEY](state, key) {
			state.sortKey = key;
		},
		[SET_NR_OF_PAGES](state, nrOfPages) {
			state.nrOfPages = nrOfPages;
		},
		[SET_CURRENT_PAGE](state, page) {
			state.currentPage = page;
		},
		[SET_VIDEOS](state, videos) {
			state.videos = videos;
		},
		[ADD_DATA](state, data) {
			state.videos = [...state.videos, ...data];
		},
		[SET_INITIAL_DATA_LOADED_STATE](state, value) {
			state.initialDataLoaded = value;
		},
		[SET_CURRENT_PAGE_LOADED_STATE](state, value) {
			state.currentPageLoaded = value;
		},
		[SET_PARAMS](state, params) {
			state.params = params;
		},
		[INCREASE_CURRENT_PAGE_COUNTER](state) {
			state.currentPage++;
		},
		[SET_INITIAL_STATE](state) {
			const freshState = getInitialState();
			for (const k in state) {
				if (k !== 'sortKey') {
					state[k] = freshState[k];
				}
			}
		},
	},
	actions: {
		async loadVideos({ state, commit, dispatch, rootGetters }) {
			commit(SET_INITIAL_DATA_LOADED_STATE, false);
			commit(SET_CURRENT_PAGE_LOADED_STATE, false);
			const event = rootGetters['event/event'];

			await dispatch('loadRelatedEvents', [
				event.id,
				state.sortKey,
			]);
			commit(SET_INITIAL_DATA_LOADED_STATE, true);
			commit(SET_CURRENT_PAGE_LOADED_STATE, true);
		},
		changeSortKey({ commit }, key) {
			commit(SET_SORT_KEY, key);
		},
		async loadRelatedEvents({ commit }, params) {
			const { meta, data } = await ApiClient.getRelatedEvents.apply(
				ApiClient,
				params
			);
			commit(SET_NR_OF_PAGES, meta.lastPage);
			commit(SET_CURRENT_PAGE, 1);
			commit(SET_VIDEOS, data);
			commit(SET_PARAMS, params);
		},
		async loadMore({ state, dispatch }) {
			if (!state.currentPageLoaded) {
				return;
			}
			await dispatch('loadNextPage');
		},
		async loadNextPage({ state, commit, getters }) {
			if (getters.isLastPage) {
				return;
			}

			commit(SET_CURRENT_PAGE_LOADED_STATE, false);
			const { data } = await ApiClient.getRelatedEvents.apply(ApiClient, [
				...state.params,
				state.currentPage + 1,
			]);
			if (data.length > 0) {
				commit(ADD_DATA, data);
				commit(INCREASE_CURRENT_PAGE_COUNTER);
			}
			commit(SET_CURRENT_PAGE_LOADED_STATE, true);
		},
		resetState({ commit }) {
			commit(SET_INITIAL_STATE);
		},
	},
	getters: {
		sortKey: (state) => state.sortKey,
		videos:  (state) => {
			return state.videos.map((video) => {
				video.durationSeconds = video.durationSeconds ?? (video.endTimestamp - video.startTimestamp);

				return {
					id:       video.id,
					title:    video.name,
					duration: video.durationSeconds > 60
						              ? formatSecondsAsHoursAndMinutes(video.durationSeconds)
						              : formatTimestampAsMinutesSeconds(video.durationSeconds),
					imageUrl:     video.imageUrl,
					uploadedDate: moment(video.start).format('dd. DD.MM.YYYY'),
					url:          video.url,
					isLive:       video.isLive,
					event:        video,
				};
			});
		},
		currentPage:       (state) => state.currentPage,
		nrOfPages:         (state) => state.nrOfPages,
		isLastPage:        (state) => state.currentPage === state.nrOfPages,
		initialDataLoaded: (state) => state.initialDataLoaded,
	},
};
